import { render } from "./Alert.vue.ts?vue&type=template&id=a0632787&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Alert.vue?vue&type=template&id=a0632787&scoped=true&ts=true"
import script from "./Alert.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Alert.vue?vue&type=script&setup=true&lang=ts"
export * from "./Alert.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Alert.vue?vue&type=script&setup=true&lang=ts"

import "./Alert.vue.scss?vue&type=style&index=0&id=a0632787&lang=scss&scoped=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Alert.vue?vue&type=style&index=0&id=a0632787&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0632787"],['__file',"src/apps/person-registration/shared-components/common/Alert.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a0632787"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a0632787', __exports__)) {
    api.reload('a0632787', __exports__)
  }
  
  module.hot.accept("./Alert.vue.ts?vue&type=template&id=a0632787&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Alert.vue?vue&type=template&id=a0632787&scoped=true&ts=true", () => {
    api.rerender('a0632787', render)
  })

}


export default __exports__